import { LinkIcon } from "lucide-react";

import { Input } from "@/components/ui/input";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface LinkTabProps {
  value: string;
  error?: string;
  disabled?: boolean;
  onChange: (value: string) => void;
}

export const LinkTab = ({ value, error, disabled, onChange }: LinkTabProps) => {
  const inputElement = (
    <div className="relative">
      <LinkIcon className="absolute left-4 top-1/2 -translate-y-1/2 size-5 text-gray-400" />
      <Input
        value={value}
        disabled={disabled}
        onChange={e => onChange(e.target.value)}
        placeholder="https://your-restaurant.com/menu"
        className="h-12 w-full rounded-md pl-12 pr-4 text-base"
      />
    </div>
  );

  return (
    <div className="flex flex-col gap-2">
      {disabled ? (
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <div className="cursor-not-allowed">{inputElement}</div>
            </TooltipTrigger>
            <TooltipContent>
              <p>
                You already have a PDF uploaded. Please remove the file first to
                use a link.
              </p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      ) : (
        inputElement
      )}

      {error && <p className="text-sm text-destructive">{error}</p>}
    </div>
  );
};
